import { makeStyles } from '@mui/styles';
import { COLORS } from '@styles/colors';

export const rockySwitcherStyles = makeStyles({
  switcher: {
    width: 30,
    height: 17,
    padding: 0,
    display: 'flex',
    marginLeft: '12px',

    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: COLORS.WHITE,
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: COLORS.ACTION.PRIMARY,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transitionProperty: 'width',
      transitionDuration: 200,
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: COLORS.TEXT.DISABLED,
      boxSizing: 'border-box',
    },
  },
});
